import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import closeBlack from 'assets/icons/customizable-close-button.svg';
import { slideUp } from 'styles/animation';

const CardContainer = styled.div`
  position: relative;
  border-radius: 10px;
  box-shadow: ${props => props.dim ? "0 0 0 100vmax rgba(0, 0, 0, .5)" : "0 13px 15px 0 rgba(80, 80, 80, 0.1)"};
  overflow: hidden;
  height: ${p => p.height ?  p.height : 'calc(100vh - 78px)'} ;
  background-color: ${p => (p.bgColor ? 'white' : 'transparent')};
  display: block;
  opacity: 0;
  transform: translateY(10px);
  will-change: transform;
  animation: ${slideUp} 0.4s ease-in-out 0.1s forwards;
  border-radius: 20px;
  ${p => p.zIndex && `z-index: ${p.zIndex};`}
  width: calc(100% - 40px);
  margin: 0 20px;
`;

const CardClose = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${p => (p.bgClose === 'white' ? 'white' : 'black')};
  background: ${p =>
    p.bgClose === 'white' ? `rgba(255, 255, 255, 0.1)` : `#EDEEF0`};
  border: 1px solid #FFFFFF;
  &:hover{
    img{
      opacity: 1;
      filter: brightness(0%);
    }
  }
  box-shadow: 0px 5px 10px rgba(80, 80, 80, 0.1);
  height: 22px;
  width: 22px;
  border-radius: 50%;
  z-index: 3;
  margin-left: auto;
  margin-right: 40px;
  margin-bottom: 10px;
  & img {
    height: 8px;
    width: 8px;
    fill: ${p => p.textColor || 'white'};
  }
`;

const CardCloseIcon = styled.img`
  height: 8px;
  width: 8px;
`;

/**
 * @param {func} onClose - to handle function programmatically
 */
const Card = ({ onClose, children, bgClose, height, zIndex, bgColor, hideClose, textColor }) => {
  const [open, isOpen] = useState(true);

  const handleClose = () => {
    if (onClose) return onClose();
    isOpen(!open);
  };

  return (
    open && (
      <>
        {onClose && !hideClose && (
            <CardClose data-testid="insent-test-card-close" id="insent-card-close" onClick={handleClose} bgClose={bgClose} textColor={textColor}>
                <CardCloseIcon src={closeBlack} />
            </CardClose>
        )}
        <CardContainer id="insent-card-container" height={height} zIndex={zIndex} bgColor={bgColor}>
          {children}
        </CardContainer>
      </>
    )
  );
};

Card.propTypes = {
  onClose: PropTypes.func,
};

export default Card;
